import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../../Components/Card/Card'
import { getLabel } from "../../../../Services/Language/LanguageService";
import { baseLang } from "../../../../Lang/BaseLang";
import { ConfigContext } from "../../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";
import AgGrid from '../../../../Components/Tables/AgGrid/AgGrid';


import { setTitlePage } from '../../../../Services/Config/ConfigService';
import { eliminarIPTelefonia, getRedTelefonia } from '../../../../../API/IT/DireccionesIP/DireccionesIPRouter';

import TelefoniaCRUD from "./TelefoniaCRUD";
import { toastShow } from '../../../../Services/ToastService';

const TelefoniaScreen = () => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [telefonia, SetTelefonia] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    const getInfo = async () => {
        setLoading(true);
        const d = await getRedTelefonia();
        SetTelefonia(d);
        setLoading(false);
    };

    const eliminarIP = async (datos) => {
      const resultado = await eliminarIPTelefonia(datos)
  
      if (resultado[0]?.ESTADO === 1) {
        toastShow(
          toast,
          "success",
          "Datos Eliminados",
          resultado[0]?.MENSAJE
        );
        getInfo();
      } else {
        toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
      }
    };

    const columns = [
        {
          header: "ID",
          headerEn:"ID",
          field: "IdDireccionIP",
          hidden: userAuth.IdRol === 1,
          className: "Xsmall",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "IP",
          headerEn:"IP",
          field: "DireccionIP",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Estado",
          headerEn: "Status",
          field: "IdStatus",
          className: "small",
          Format: "Estado",
          frozen:true,
          alignFrozen:'right', 
          filter:false,    
          body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
        },
        {
          header: "Nombre Dispositivo",
          headerEn:"Device Name",
          field: "NombreDispositivo",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Tipo Dispositivo",
          headerEn:"Device Type",
          field: "TipoDispositivo",
        },
        {
          header: "Marca",
          headerEn:"Brand",
          field: "Marca",
        },
        {
          header: "Modelo",
          headerEn:"Model",
          field: "Modelo",
        },
        {
          header: "Serie",
          headerEn:"Series",
          field: "Serie",
        },
        {
          header: "Extensión",
          headerEn:"Extension",
          field: "Extencion",
        },
        {
          header: "Area",
          headerEn:"Area",
          field: "Area",
        },
        {
          header: "Asignado a",
          headerEn:"Assigned to",
          field: "NombreEmpleado",
        },
        {
          header: "AnyDesk",
          headerEn:"AnyDesk",
          field: "AnyDesk",
        },
        {
          header: "Comentario",
          headerEn:"Comment",
          field: "Comentarios",
        },
        {
          field: "IdDireccionIP",
          className: "",
          header: "",
          Format: "Botones",
          frozen: true,
          alignFrozen: "right",
          filter: false,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                setShowDialog(true);
                setSelected(rowData);
              },
            },
            {
              icon: "pi pi-trash",
              tooltip: "Eliminar",
              onClick: (rowData) => {
                eliminarIP(rowData)
              },
            },
          ],
        },
    ]

    const table = {
        Columns: columns,
        Data: telefonia,
        loading: loading
    };


    useEffect(() => {
      setTitlePage(getLabel(baseLang, "telefonia", config.language));
      getInfo();
    }, []);



    return (
        <div className=" p-fluid px-4" style={{ width: "100%", height: "100%", margin: "auto" }}>
            <Toast ref={toast} />
            <Card
                titulo={
                <div className='botones'>
                    <h3>{getLabel(baseLang, "telefonia", config.language)}</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                    <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
                </div>}
                contenido={<div className='p-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />

            {showDialog && 
              <TelefoniaCRUD 
                telefonia={telefonia}
                toastRef={toast} 
                showDialog={showDialog} 
                setShowDialog={setShowDialog}
                selected={selected} 
                getInfo={getInfo} 
                modo={selected ? "Editar" : "Crear"}/>
            }
        </div>
    )
}

export default TelefoniaScreen;